import { SocialIconName } from 'design-system/components/Icon';

export enum EHomepageTabSectionKey {
  Introduction = 'HomePage_Introduction',
  Events = 'HomePage_Events',
  MaybeYouKnow = 'HomePage_MayBeYouKnow',
  SuggestedCourses = 'HomePage_SuggestedCourses',
  HighlightCourses = 'HomePage_HighlightCourses',
  HighlightVideos = 'HomePage_HighlightVideos',
  Footer = 'HomePage_Footer',
  FeaturedTopics = 'HomePage_FeaturedTopics',
  NavigateButton = 'HomePage_NavigateButton',
  Custom1 = 'HomePage_Custom1',
  Custom2 = 'HomePage_Custom2',
  Custom3 = 'HomePage_Custom3',
  Custom4 = 'HomePage_Custom4',
  Custom5 = 'HomePage_Custom5',
  Custom6 = 'HomePage_Custom6',
  Custom7 = 'HomePage_Custom7',
  Custom8 = 'HomePage_Custom8',
  Custom9 = 'HomePage_Custom9',
  Custom10 = 'HomePage_Custom10',
  LiveStream = 'HomePage_LiveStream',
}

export interface IHomepageTabIntroductionSection {
  title: string;
  content: string;
  image: string;
  videoUrl: string;
  thumbnail: string | null;
  isUploadVideo: boolean;
  titleColor: string;
}

export interface IHomepageTabEventSection {
  banners: string[];
  links: string[];
}

export interface IHomepageTabSuggestedCoursesSection {
  courses: string[];
}

export interface IHomepageTabHighlightVideosSection {
  videos: {
    videoUrl: string;
    thumbnail: string;
    title: string;
    content: string;
    createdAt: string;
  }[];
}

export interface IHomepageTabFooterSection {
  logoUrl: string;
  footerContent: Array<{
    title: string;
    links: Array<{
      title: string;
      url?: string;
      iconName?: SocialIconName;
    }>;
  }>;
}

export interface IHomepageTabFeaturedTopicsSection {
  topics: Array<{
    id: string;
    title: string;
    url: string;
    image: string;
  }>;
}

export interface IHomepageTabCustomSection {
  topics: Array<{
    id: string;
    title: string;
    url: string;
    image: string;
  }>;
}

export interface IHomepageTabNavigateButtonSection {
  navigate: {
    title: string;
    url: string;
  };
}

export interface IHomepageTabLiveStreamSection {
  title: string;
  content: string;
  startTime: {
    date: string;
    hours: number;
    minutes: string;
  };
  optionButton: {
    title: string;
    link: string;
    enable: boolean;
  };
  thumbnail: string;
  liveStreamUrl: string;
}

export type TEnterpriseProfileHomepageTabSectionElements =
  | IHomepageTabIntroductionSection
  | IHomepageTabEventSection
  | IHomepageTabSuggestedCoursesSection
  | IHomepageTabHighlightVideosSection
  | IHomepageTabFooterSection
  | IHomepageTabFeaturedTopicsSection
  | IHomepageTabNavigateButtonSection
  | IHomepageTabLiveStreamSection
  | IHomepageTabCustomSection;

export type TEnterpriseProfileHomepageTabSection = {
  sectionName: string;
  sectionKey: EHomepageTabSectionKey;
  elements?: TEnterpriseProfileHomepageTabSectionElements;
  isActive: boolean;
}[];
